import { useEffect, useState } from 'react';

import { RELEVANCE_SORT } from '@flintmint/web-shared/components/sort-menu';
import type { SortParams, SortString } from '@/constants/types';
import { getSortModel } from '@/utils/helper-utils';

// During a term search the menu defaults to Relevance (no sortBy → engine score
// order); an explicit pick overrides until the term clears back to browseSort.
export const useSearchSort = (term: string, browseSort: SortParams | null) => {
  const [searchSort, setSearchSort] = useState<SortParams | null>(null);
  const isSearching = !!term.trim();

  useEffect(() => {
    if (!isSearching) setSearchSort(null);
  }, [isSearching]);

  const menuSort = isSearching ? searchSort ?? RELEVANCE_SORT : browseSort;
  const querySort: SortString | undefined = menuSort?.key === 'relevance' ? undefined : getSortModel(menuSort);

  return { isSearching, menuSort, querySort, setSearchSort };
};
